export default __webpack_public_path__ + "assets/shaheen.7658b7df.jpg";